(function (angular) {
    'use strict';

    angular.module('settings')

        /**
         *
         */
        .factory('companyBillingService',
            ['$http', '$q', 'portalConfig', 'sharedDataService',
                function ($http, $q, portalConfig, sharedDataService) {

                    var urlBase = portalConfig.urlBase;
                    // urlBase = 'http://localhost:8002';

                    var fac = {
                        getCompanyDetails: getCompanyDetails,
                        updateCompanyDetails: updateCompanyDetails
                    };

                    return fac;


                    function getCompanyDetails(accountId, refresh) {

                        if (sharedDataService.getCompanyDetails() && !refresh) {
                            return $q.resolve(sharedDataService.getCompanyDetails());
                        } else {
                            return $http.get(urlBase + "/membership/accounts/" + accountId)
                                .then(getCompanyDetailsComplete)
                                .catch(getCompanyDetailsFailed);
                        }

                        function getCompanyDetailsComplete(response) {
                            sharedDataService.setCompanyDetails(response.data);
                            return response.data;
                        }

                        function getCompanyDetailsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function updateCompanyDetails(accountId, data) {

                        return $http.put(urlBase + "/membership/accounts/" + accountId, data)
                            .then(updateCompanyDetailsComplete)
                            .catch(updateCompanyDetailsFailed);

                        function updateCompanyDetailsComplete(response) {
                            sharedDataService.setCompanyDetails(response.data);
                            return response.data;
                        }

                        function updateCompanyDetailsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);